import { useGlobals } from 'hooks/useGlobals';
import type { ShopifyProductLight } from 'types/product/ShopifyProductLight';

interface UseShopifyProductsOptions {
  handles?: string[];
  merchandiseIds?: string[];
}

export const useShopifyProducts = ({
  handles,
  merchandiseIds,
}: UseShopifyProductsOptions): ShopifyProductLight[] => {
  const { data: globals } = useGlobals();

  if (handles) {
    return (
      globals?.shopifyProducts?.filter((p) => handles.includes(p.handle)) || []
    );
  }

  if (merchandiseIds) {
    return (
      globals?.shopifyProducts?.filter((p) =>
        p.variants.some((v) => merchandiseIds.includes(v.id)),
      ) || []
    );
  }

  return [];
};
